import React from 'react';
import './AddNewPage.scss';

export default function AddNewPage() {
  return (
    <div className="add-new-page">
      <div className="upper-fields">
        <div className="form-container">
          <div className="form-group">
            <label htmlFor="navbar">NAVIGATION BAR</label>
            <input type="text" id="navbar" placeholder="Enter navigation bar name" />
          </div>

          <div className="form-group">
            <label htmlFor="pageName">PAGE NAME</label>
            <input type="text" id="pageName" placeholder="Enter page name" />
          </div>

          <div className="form-group">
            <label htmlFor="pageType">PAGE CATEGORY</label>
            <select id="pageType">
              <option value="">Select type</option>
              <option value="type1">Type 1</option>
              <option value="type2">Type 2</option>
              <option value="type3">Type 3</option>
              <option value="type4">Type 4</option>
            </select>
          </div>
        </div>

        <div className="form-container">
       <div className="row">
  <div className="col-md-6">
    <div className="form-group">
      <label htmlFor="pageTypeA">STATUS</label>
      <select id="pageType">
              <option value="">Select type</option>
              <option value="type1">Type 1</option>
              <option value="type2">Type 2</option>
              <option value="type3">Type 3</option>
              <option value="type4">Type 4</option>
            </select>
    </div>
  </div>

  <div className="col-md-6 mb-3">
    <div className="form-group">
      <label htmlFor="pageTypeB">VISIBILIBTY</label>
       <select id="pageType">
              <option value="">Select type</option>
              <option value="type1">Type 1</option>
              <option value="type2">Type 2</option>
              <option value="type3">Type 3</option>
              <option value="type4">Type 4</option>
            </select>
    </div>
  </div>

   <div className="form-group">
            <label htmlFor="navbar">BUBLISH SCHDULE</label>
            <input type="text" id="navbar" placeholder="Enter navigation bar name" />
          </div>
</div>

        </div>
      </div>

      <div className="bottom-section">
        <div className="form-container">
          <div className="form-group">
            <label htmlFor="navbar3">NAVIGATION BAR</label>
            <input type="text" id="navbar3" placeholder="Enter navigation bar name" />
          </div>

          <div className="form-group">
            <label htmlFor="pageName3">PAGE NAME</label>
            <input type="text" id="pageName3" placeholder="Enter page name" />
          </div>

          <div className="form-group">
            <label htmlFor="pageType3">PAGE TYPE</label>
            <select id="pageType3">
              <option value="">Select type</option>
              <option value="type1">Type 1</option>
              <option value="type2">Type 2</option>
              <option value="type3">Type 3</option>
              <option value="type4">Type 4</option>
            </select>
          </div>
        </div>

      
      </div>
        <div className="form-buttons">
          <button type="submit" className="publish">PUBLISH</button>
          <button type="button" className="cancel">CANCEL</button>
        </div>
    </div>
  );
}
